<script setup>
import {reactive, onMounted, watch, ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";
import { Bar } from 'vue-chartjs';
import 'chart.js/auto';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement } from 'chart.js';

const props = defineProps({
  start: String,
  end: String
});

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement);
ChartJS.defaults.defaultFontFamily = 'Lato';
ChartJS.defaults.defaultFontSize = 18;
ChartJS.defaults.defaultFontColor = '#000';

const data = reactive({
  startDate: props.start,
  endDate: props.end,
  dataLoading: false,
  adjusters: [],
  reviewers: [],
  clients: [],
  adjusterPercent: 0,
  reviewerPercent: 0,
  clientPercent: 0,
  headers: [
    { title: 'Name', key: 'name' },
    { title: 'Total Claims', key: 'total' },
    { title: 'Returned Claims', key: 'returned' },
    { title: '% Returned', key: 'percent_returned' },
  ]
});

const chartData = reactive({
  labels: ['Adjusters','Reviewers','Clients'],
  datasets: [{
    data: [0,0,0]
  }]
})

const chartOptions = reactive({
  maintainAspectRatio: true,
  responsive: true,
  scales: {
    y: {
      beginAtZero: true,
      min: 0,
      max: 100,
      ticks: {
        stepSize: 10 // Optional: Adjust the interval between ticks
      }
    }
  },
  plugins: {
    title: {
      display: true,
      text: '% of Claims Returned for Corrections',
      fontSize: 25,
    },
    legend: {
      display: false
    }
  }
})

const getAverageCorrectionsPercentage = (correctionsArr) => {
  if(correctionsArr.length > 0){
    let total = 0;
    let returned = 0;
    for(let row of correctionsArr){
      if(Object.prototype.hasOwnProperty.call(row,'total')){
        total += parseInt(row.total)
      }
      if(Object.prototype.hasOwnProperty.call(row,'returned')){
        returned += parseInt(row.returned)
      }

    }
    return Math.trunc(((returned/total)*100))
  }
  else{
    return 0;
  }

}

const getData = () =>{
  data.loading = true;
  ApiWrapper.post('corrections', 'list', {
    startDate: data.startDate,
    endDate: data.endDate
  })
      .then((response) => {
        if(response){
          chartData.datasets[0].data = [];
          if(response.adjuster){
            if(response.adjuster.length > 0){
              chartData.datasets[0].data.push(getAverageCorrectionsPercentage(response.adjuster));
            }
            else{
              chartData.datasets[0].data.push(0);
            }
          }
          if(response.reviewer){
            if(response.reviewer.length > 0){
              chartData.datasets[0].data.push(getAverageCorrectionsPercentage(response.reviewer));
            }
            else{
              chartData.datasets[0].data.push(0);
            }
          }
          if(response.client){
            if(response.client.length > 0){
              chartData.datasets[0].data.push(getAverageCorrectionsPercentage(response.client));
            }
            else{
              chartData.datasets[0].data.push(0);
            }
          }
        }
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
      .finally(()=> {
        data.loading = false
      })
}

watch(()=>props.start,(newStart)=>{
  data.startDate = newStart;
  getData();
})

watch(()=>props.end,(newEnd)=>{
  data.endDate = newEnd;
  getData();
})

onMounted(()=>{
  getData();
})
</script>

<template>
  <v-container>
    <v-card height="auto" width="auto" v-if="!data.loading">
      <v-card-item>
        <v-card-title>
          Correction Statistics
        </v-card-title>
      </v-card-item>
      <v-card-item>
        <Bar :key="chartData" :data="chartData" :options="chartOptions" />
      </v-card-item>
    </v-card>
  </v-container>
</template>

<style scoped>

</style>